import LoginContainer from "@containers/auth/login";
import AuthLayout from "@layouts/auth";

const Login = () => {
    return (
        <AuthLayout
            title="ورود"
            description="برای ورود شماره همراه و کلمه عبور خود را وارد نمایید">
            <LoginContainer />
        </AuthLayout>
    );
};

export default Login;
